<p-dialog 
  [visible]="true" 
  [modal]="true" 
  [draggable]="false" 
  [resizable]="false"
  styleClass="!rounded-[2rem] overflow-hidden shadow-2xl"
  contentStyleClass="!p-0"
  (onHide)="close.emit()"
  [style]="{ width: '450px' }"
  [breakpoints]="{ '640px': '90vw' }"
>
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full pr-8">
      <div class="flex flex-col gap-0.5">
        <h3 class="text-xl font-bold text-slate-800">
          <ng-container *ngIf="showDeleteConfirm">{{ 'confirm_delete' | translate }}</ng-container>
          <ng-container *ngIf="!showDeleteConfirm">
            {{ (isEditMode ? 'action_edit' : 'action_add') | translate }}
            {{ (type === 'diagnostic' ? ('diagnostics_label' | translate) : ('treatments_label' | translate)) }}
          </ng-container>
        </h3>
        <p *ngIf="!showDeleteConfirm" class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
          {{ typeLabel }}
        </p>
      </div>
      
      <!-- Delete Icon in Header -->
      <button 
        *ngIf="isEditMode && !showDeleteConfirm"
        type="button"
        (click)="showDeleteConfirm = true"
        class="w-10 h-10 flex items-center justify-center rounded-xl text-slate-400 hover:text-rose-500 hover:bg-rose-50 transition-all ml-auto outline-none"
        [title]="'action_delete' | translate"
      >
        <i class="pi pi-trash"></i>
      </button>
    </div>
  </ng-template>

  <div class="w-full flex flex-col max-h-[90vh]">
    <!-- Content -->
    <div class="px-8 py-6 overflow-y-auto">
      
      <!-- Delete Confirmation View -->
      <div *ngIf="showDeleteConfirm" class="flex flex-col items-center gap-6 py-4 animate-fadeIn">
        <div class="w-20 h-20 rounded-[2.5rem] bg-rose-50 flex items-center justify-center text-rose-500">
          <i class="pi pi-trash text-4xl"></i>
        </div>
        <div class="flex flex-col gap-2 text-center">
          <h3 class="text-xl font-bold text-slate-800">{{ 'confirm_delete' | translate }}</h3>
          <p class="text-sm font-medium text-slate-500">
            {{ 'confirm_delete_text' | translate }} <span class="font-bold text-slate-700">"{{ item.name }}"</span>?
          </p>
          <!-- Without this the links vanish silently and future AI imports
               quietly stop resolving to this diagnosis. -->
          <div *ngIf="linkedProviderNames.length"
            class="mt-2 px-4 py-3 rounded-2xl bg-amber-50 border border-amber-200 text-left">
            <p class="text-[11px] font-black text-amber-700 uppercase tracking-wider flex items-center gap-2">
              <i class="pi pi-exclamation-triangle text-[11px]"></i>
              {{ 'DTP_DELETE_BREAKS_LINKS' | translate: { count: linkedProviderNames.length } }}
            </p>
            <p class="text-[11px] font-bold text-amber-600 mt-1">{{ linkedProviderNames.join(', ') }}</p>
          </div>
        </div>
        
        <div class="flex gap-4 w-full pt-4">
          <app-button 
            [label]="'common_no' | translate"
            variant="secondary"
            (onClick)="showDeleteConfirm = false"
            class="flex-1"
          ></app-button>
          <app-button 
            [label]="'common_yes_delete' | translate"
            [variant]="'danger'"
            [loading]="saving"
            (onClick)="delete()"
            class="flex-1"
          ></app-button>
        </div>
      </div>

      <!-- Main Form View -->
      <form *ngIf="!showDeleteConfirm" [formGroup]="form" (ngSubmit)="save()" class="flex flex-col gap-6">
        <div class="flex flex-col gap-2.5">
          <label class="text-sm font-bold text-slate-700 ml-1">
            {{ 'patient_field_name' | translate }} <span class="text-rose-500">*</span>
          </label>
          <input 
            pInputText
            formControlName="name"
            type="text" 
            [placeholder]="'placeholder_enter_name' | translate"
            class="!w-full !rounded-2xl !bg-slate-50/50 !border-slate-100 !px-4 !py-3 !text-sm focus:!ring-primary/10 focus:!border-primary transition-all shadow-sm"
          >
        </div>

        <div class="flex flex-col gap-2.5">
          <label class="text-sm font-bold text-slate-700 ml-1">
            {{ 'patient_field_observations' | translate }}
          </label>
          <textarea 
            pInputTextarea
            formControlName="description"
            rows="4"
            [placeholder]="'placeholder_enter_description' | translate"
            class="!w-full !rounded-2xl !bg-slate-50/50 !border-slate-100 !px-4 !py-3 !text-sm focus:!ring-primary/10 focus:!border-primary transition-all shadow-sm resize-none"
          ></textarea>
        </div>
      </form>
    </div>

    <!-- Footer -->
    <div *ngIf="!showDeleteConfirm" class="p-8 border-t border-slate-50 flex justify-end gap-4 shrink-0">
      <app-button 
        [label]="'button_cancel' | translate"
        variant="secondary"
        (onClick)="close.emit()"
        class="flex-1 sm:flex-initial"
      ></app-button>
      <app-button 
        [label]="(saving ? ('saving' | translate) : ('button_save' | translate))"
        [loading]="saving"
        [disabled]="form.invalid"
        (onClick)="save()"
        class="flex-1 sm:flex-initial min-w-[120px]"
      ></app-button>
    </div>
  </div>
</p-dialog>
